import { render, staticRenderFns } from "./createCenterAllocationForm.vue?vue&type=template&id=1de93c9a&"
import script from "./createCenterAllocationForm.vue?vue&type=script&lang=js&"
export * from "./createCenterAllocationForm.vue?vue&type=script&lang=js&"
import style0 from "./createCenterAllocationForm.vue?vue&type=style&index=0&id=1de93c9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports